import "./accordion.scss";

const selectors = {
  container: "[data-acc]",
  item: "[data-acc-item]",
  itemHeader: "[data-acc-item-header]",
  active: "active",
};

const initAccordion = (container) => {
  const accordions = container.querySelectorAll(selectors.item);

  accordions.forEach((accordion) => {
    const header = accordion.querySelector(selectors.itemHeader);

    header.addEventListener("click", () => {
      accordion.classList.toggle(selectors.active);
    });
  });
};

document.addEventListener("DOMContentLoaded", async function () {
  const containers = document.querySelectorAll(selectors.container);

  containers?.forEach(initAccordion);
});
